import { render, staticRenderFns } from "./ed-link.vue?vue&type=template&id=4191cc09&scoped=true&"
import script from "./ed-link.ts?vue&type=script&lang=js&"
export * from "./ed-link.ts?vue&type=script&lang=js&"
import style0 from "./ed-link.scss?vue&type=style&index=0&id=4191cc09&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4191cc09",
  null
  
)

export default component.exports